// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3L678","media":"styles_media__1WUZH","info":"styles_info__2m5IH","title":"styles_title__2zLPu","description":"styles_description__3ViTs"};